// Helper hook + utilities for foreign-flow chips on screener and stock detail.
import { useEffect, useState } from "react";
import { apiGet } from "@/lib/api";

/**
 * Returns a map: cse_symbol → { direction: 'buy'|'sell', amount_lkr_mn, date }
 * Cached for the lifetime of the page.
 */
let _cache = null;
let _cachePromise = null;

export function useForeignFlowChips() {
  const [data, setData] = useState(_cache || {});

  useEffect(() => {
    if (_cache) return;
    if (!_cachePromise) {
      _cachePromise = apiGet("/market-intelligence/screener-foreign-chips")
        .then((d) => { _cache = d || {}; return _cache; })
        .catch(() => { _cache = {}; return _cache; });
    }
    _cachePromise.then((d) => setData(d));
  }, []);

  return data;
}

export function getForeignFlowChip(map, cseSymbol) {
  if (!map || !cseSymbol) return null;
  const entry = map[cseSymbol];
  if (!entry || entry.amount_lkr_mn == null) return null;
  if (entry.amount_lkr_mn < 10) return null; // threshold: Rs.10M
  return entry;
}
